<template>
  <div class="jiankuang-tab">
    <div class="no-results" v-if="noData">
    </div>
    <template v-else>
      <div class="content-box">
        <p class="title">主要指标({{ShareholderEquity.EndDate ? ShareholderEquity.EndDate.replace(/^(.{4})|(.{2})$/g, '$1-$2') : ''}})</p>
        <div class="box">
          <div style="flex: 1;margin-right: 10px;">
            <div class="line-between">
              <span>市盈(动)</span>
              <span>{{FMainIndex.Pe ? toFixed(FMainIndex.Pe) : '--'}}</span>
            </div>
            <div class="line-between">
              <span>每股收益</span>
              <span>{{FMainIndex.Basiceps ? formatUnit(FMainIndex.Basiceps) + '元' : '--'}}</span>
            </div>
            <div class="line-between">
              <span>营业收入</span>
              <span>{{FMainIndex.BizTotinco ? formatUnit(FMainIndex.BizTotinco) : '--'}}</span>
            </div>
            <div class="line-between">
              <span>净利润</span>
              <span>{{FMainIndex.NetProfit ? formatUnit(FMainIndex.NetProfit) : '--'}}</span>
            </div>
          </div>
          <div style="flex: 1;margin-left: 10px;">
            <div class="line-between">
              <span>市净率</span>
              <span>{{FMainIndex.Nav ? toFixed(FMainIndex.Nav) : '--'}}</span>
            </div>
            <div class="line-between">
              <span>每股净资产</span>
              <span>{{FMainIndex.Naps ? formatUnit(FMainIndex.Naps) + '元' : '--'}}</span>
            </div>
            <div class="line-between">
              <span>营收同比</span>
              <span>{{FMainIndex.Tagrt ? toFixed(FMainIndex.Tagrt) + '%' : '--'}}</span>
            </div>
            <div class="line-between">
              <span>净利润同比</span>
              <span>{{FMainIndex.Npgrt ? toFixed(FMainIndex.Npgrt) + '%' : '--'}}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div style="height: 0.06rem;background: #f5f5f5;"></div>

      <div class="content-box">
        <p class="title">公司简介</p>
        <div class="box column">
          <div class="box-form-item">
            <label for="">公司名称</label>
            <span>{{CompanyProfile.CompName}}</span>
          </div>
          <div class="box-form-item-block">
            <div class="label">公司简介</div>
            <div ref="gsjjbox" :class="`${showMoreCompIntro ? 'normal-text' : 'threeline-text'}`">{{CompanyProfile.CompIntro}}</div>
            <template v-if="CompanyProfile.CompIntro && CompanyProfile.CompIntro.length > 48">
              <div v-if="!showMoreCompIntro" class="down-btn" @click="showMoreCompIntro = true">展开<i class="downrect-ico"></i></div>
              <div v-else class="down-btn" @click="showMoreCompIntro = false">收起<i class="uprect-ico"></i></div>
            </template>
          </div>
          <div class="box-form-item">
            <label for="">所属行业</label>
            <span>{{CompanyProfile.Industry}}</span>
          </div>
          <div class="box-form-item">
            <label for="">上市时间</label>
            <span>{{CompanyProfile.ListDate}}</span>
          </div>
          <div class="box-form-item">
            <label for="">发行价</label>
            <span>{{CompanyProfile.IssPrice}}元</span>
          </div>
          <div class="box-form-item-block">
            <div class="label">办公地址</div>
            <div class="twoline-text">{{CompanyProfile.OfficeAddr}}</div>
            <!-- <label for="">办公地址</label>
            <span>{{CompanyProfile.OfficeAddr}}</span> -->
          </div>
          <div class="box-form-item-block">
            <div class="label">主营业务</div>
            <div ref="zyywbox" :class="`${showMoreMajorBiz ? 'normal-text' : 'threeline-text'}`">{{CompanyProfile.MajorBiz}}</div>
            <template v-if="CompanyProfile.MajorBiz && CompanyProfile.MajorBiz.length > 48">
              <div v-if="!showMoreMajorBiz" class="down-btn" @click="showMoreMajorBiz = true">展开<i style="right:1.5rem;" class="downrect-ico"></i></div>
              <div v-else class="down-btn" @click="showMoreMajorBiz = false">收起<i style="right:1.5rem;" class="uprect-ico"></i></div>
            </template>
            <!-- <label for="">主营业务</label>
            <span>{{CompanyProfile.MajorBiz}}</span> -->
          </div>
          <div>
            <label for="">主营业务构成</label>
            <div id="main" style="width: 100%;height:300px;"></div>
          </div>
          <div v-if="buslist.length > 0">
            <div class="majortitle">
              <p>业务</p>
              <p>营业收入</p>
            </div>
            <div style="display: flex;justify-content: space-between;padding-top: 5px;" v-for="(item, index) in buslist" :key="index">
              <p style="display: flex;align-items: center;">
                <i class="lengend-ico" :style="`background: ${color[index % 4]}`"></i><span>{{item.ClassName}}</span>
              </p>
              <p>{{item.TcoreBizIncome ? formatUnit(item.TcoreBizIncome) : '--'}}</p>
            </div>
          </div>
        </div>
        <p class="title" :style="{'margin-top': '20px'}">股东股本{{ShareholderEquity.EndDate ? `(${ShareholderEquity.EndDate.replace(/^(.{4})|(.{2})$/g, '$1-$2')})` : '--'}}</p>
        <div class="box-between">
          <label for="">总股本</label>
          <span>{{ShareholderEquity.ToTalShare ? formatUnit(ShareholderEquity.ToTalShare * 10000) : '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">流通股本</label>
          <span>{{ShareholderEquity.CircSkamt ? formatUnit(ShareholderEquity.CircSkamt * 10000) : '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">股东人数</label>
          <span>{{ShareholderEquity.ToTalShamt ? formatUnit(ShareholderEquity.ToTalShamt) : '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">较上期增减户数</label>
          <span v-if="ShareholderEquity.ToTalShrto > 0">增加{{ShareholderEquity.ToTalShrto}}</span>
          <span v-else>减少{{ShareholderEquity.ToTalShrto * -1}}</span>
        </div>
        <div class="box-between">
          <label for="">户均持股</label>
          <span>{{ShareholderEquity.Kavgsh ? formatUnit(ShareholderEquity.Kavgsh): '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">第一大股东</label>
          <span>{{ShareholderEquity.Top1Holder ? ShareholderEquity.Top1Holder : '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">前十大股东占比</label>
          <span>{{ShareholderEquity.HolderRto ? toFixed(ShareholderEquity.HolderRto) + '%' : '--'}}</span>
        </div>
        <div class="box-between">
          <label for="">前十大流通股东占比</label>
          <span>{{ShareholderEquity.OthoLderRto ? toFixed(ShareholderEquity.OthoLderRto) + '%' : '--'}}</span>
        </div>
      </div>

      <div style="height: 0.06rem;background: #f5f5f5;" v-if="dividends.length > 0"></div>

      <div class="content-box" v-if="dividends.length > 0">
        <p class="title">分红送配</p>
        <ul class="diviend-header">
          <li>年份</li>
          <li>方案</li>
          <li>除权日</li>
        </ul>
        <ul class="diviend-body" v-for="(item, index) in !showMoreDiv ? dividends.slice(0, 3) : dividends" :key="index">
          <li>{{item.PlaceYear}}</li>
          <li>{{item.ActTotalLotrt}}</li>
          <li>{{item.ExRightDate}}</li>
        </ul>
        <div v-if="!showMoreDiv" class="down-btn" @click="showMoreDiv = true">展开<i class="downrect-ico more"></i></div>
        <div v-else class="down-btn" @click="showMoreDiv = false">收起<i class="uprect-ico more"></i></div>
      </div>
    </template>
  </div>
</template>

<script>
import {request} from '@/api/request'
import {mapState} from 'vuex'
import { formatUnit, toFixed } from '@/utils/formatUnit.js'
import echarts from 'echarts'

export default {
  data() {
    return {
      screenWidth: screen.width,
      color: ['#9d9d9d','#ffa839','#48affb', '#2881cd'],
      noData: false,
      FMainIndex: {},
      CompanyProfile: {},
      ShareholderEquity: {},
      buslist: [],
      dividends: [],
      showMoreDiv: false,
      showMoreCompIntro: false,
      showMoreMajorBiz: false,
      barChart: null,
      barOptions: {
        title: {
          text: '主营构成',
          top: '48%',
          right: '34%',
          textAlign: 'center',
          textVerticalAlign: 'middle',
          textStyle: {
            fontSize: '13',
            color: '#666',
          }
        },
        color: ['#9d9d9d','#ffa839','#48affb', '#2881cd'],
        legend: {
          show: false,
        },
        tooltip: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            animation: false,
            hoverAnimation: false,
            legendHoverLink: false,
            tooltip: {
              // show: false,
              formatter: '{a}'
            },
            radius: ['30%', '50%'],
            itemStyle: {
              borderColor: '#fff',
              borderWidth: '2'
            },
            label: {
              formatter: `{b}`,
              color: '#666',
              fontSize: '14',
            },
            labelLine: {
              lineStyle: {
                color: '#666'
              }
            },
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      code: state => state.code,
      market: state => state.market,
      symbol: state => state.symbol,
      tabs: state => state.common.tabs,
      tabIndex: state => state.common.tabIndex
    }),
    threeHeight() {
      console.log('12312', this.screenWidth > 400 ? 73 : 63)
      return this.screenWidth > 400 ? 73 : 63
    }
  },
  created() {
    this.initData()
    this.barOptions.series[0].data = this.buslist
  },
  mounted() {
    this.barChart = echarts.init(document.getElementById('main'))
    this.barChart.setOption(this.barOptions)
  },
  methods: {
    async initData() {
      let res = await request.post({
        url: request.apis.quote.getAShareProfile,
        params: {
          Ei: this.market + this.symbol
        }
      })

      if (res.FMainIndex.EndDate === '' && res.CompanyProfile.CompName === '' && res.ShareholderEquity.EndDate === '') {
        this.noData = true
      } else {
        this.noData = false
        this.FMainIndex = res.FMainIndex
        this.CompanyProfile = res.CompanyProfile
        this.ShareholderEquity = res.ShareholderEquity
        let bus = res.MainBusinessComposition
        
        let sum = bus.reduce((v1, v2) => {
          let temp = Object.assign({}, v2)
          temp.TcoreBizIncome = v1.TcoreBizIncome + v2.TcoreBizIncome
          return temp
        }).TcoreBizIncome
        
        bus.map(busitem => {
          busitem.TrevenueIsPctge = busitem.TcoreBizIncome / sum * 100
          return busitem
        })

        this.buslist = bus
        this.barOptions.series[0].data = bus.filter(b => Math.abs(b.TrevenueIsPctge) > 10).map(item => ({
          value: Math.abs(this.toFixed(item.TrevenueIsPctge)),
          name: item.ClassName
        }))
        this.barChart.setOption(this.barOptions)

        let dividend = await request.post({
          url: request.apis.quote.getDividendDistribution,
          params: {
            Ei: `${this.market}${this.symbol}`,
            Num: 1000,
            PageIndex: 0
          }
        })

        this.dividends = dividend.datas

      }
    },
    formatUnit,
    toFixed
  }
}
</script>

<style lang="stylus" scoped>
.jiankuang-tab
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .content-box
    .title
      font-size 15px
      color #333333
      font-weight 600
      height 21px
      line-height 21px
      margin 0px 12px
      padding 6px 0
      border-bottom 1px solid #edeff3
    .diviend-header
      display flex
      justify-content space-between
      font-size 13px
      color #666
      padding 9px 0
      margin 0 12px
      li
        flex 1
        text-align right
      li:first-child
        text-align left
    .diviend-body
      display flex
      justify-content space-between
      font-size 15px
      color #333
      padding-bottom 10px
      margin 0 12px
      li
        flex 1
        text-align right
      li:first-child
        text-align left
    .down-btn
      display flex
      color #409afb
      justify-content: center
      align-items baseline
      position relative
      font-size 12px
      .downrect-ico
        background url('../../../assets/downrect.png')
        width 11px
        height 11px
        display block
        background-size contain
        background-repeat no-repeat
        position absolute
        left 190px
        top 6px
      .uprect-ico
        background url('../../../assets/downrect.png')
        width 11px
        height 11px
        display block
        background-size contain
        background-repeat no-repeat
        transform: rotate(180deg)
        position absolute
        left 190px
        bottom 6px
      .more
        left 200px
    .box-between
      display flex
      justify-content space-between
      font-size 15px
      color #333
      padding-top 10px
      margin 0 12px
    .box
      display flex
      margin 5px 12px
      &.column
        flex-flow column
      .majortitle
        display flex
        justify-content space-between
        color #666
        font-size 13px
      .lengend-ico
        width 13px
        height 13px
        background #9d9d9d
        display block
        margin-right 10px
      .box-form-item-block
        display block
        font-size 15px
        color #333333
        font-weight 400
        padding 7px 0
        .label
          width 70px
          float left
        .twoline-text
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          // margin-left 20px
          text-align justify
          padding-left 20px
        .threeline-text
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          // margin-left 20px
          text-align justify
          padding-left 20px
        .normal-text
          // overflow : hidden;
          // text-overflow: ellipsis;
          display: -webkit-box;
          // -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          // margin-left 20px
          text-align justify
          padding-left 20px
      .box-form-item
        font-size 15px
        color #333333
        font-weight 400
        padding 7px 0
        display flex
        label
          width 70px
          display block
          margin-right 20px
      .line-between
        display flex 
        justify-content space-between
        font-size 15px
        padding 5px 0
        color #333333
        span
          &:last-child
            color #666
        sup
          font-size 10px
</style>